import "./footer.css";

import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-ul-links">
        <ul className="footer-links">
          <li>
            <Link to="/" className="footer-link">
              {" "}
              الرئيسية
            </Link>
          </li>
          <li className="footer-link">
            <Link to="/doctors" className="footer-link">
              {" "}
              الاطباء
            </Link>
          </li>
          <li>
            <Link to="/about" className="footer-link">
              {" "}
              من نحن
            </Link>
          </li>
        </ul>
      </div>
      <div className="right">
        Design & Development By <span>Ahmed osman</span>
      </div>
    </div>
  );
};

export default Footer;
